export default __webpack_public_path__ + "static/media/size_chart_dimensions.926732b7.png";